import { render, staticRenderFns } from "./OrderViewer.vue?vue&type=template&id=b93b1eca&scoped=true"
import script from "./OrderViewer.vue?vue&type=script&lang=js"
export * from "./OrderViewer.vue?vue&type=script&lang=js"
import style0 from "./OrderViewer.vue?vue&type=style&index=0&id=b93b1eca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93b1eca",
  null
  
)

export default component.exports